export const appStoreIosRedirectLinkApp = "itms-apps://itunes.apple.com/app/id1626790356"

export const chPlayAndroiRedirectLinkApp = (id: string) => `http://play.google.com/store/apps/details?id=${id}`
